module.exports = __webpack_public_path__ + "img/logo-principal.11fa12e3.png";